export const sortByFields = {
	publicationDateDesc: {
		name: 'Publication Date (newest first)',
		filter: [{ datePublished: { order: 'desc', missing: '_last' } }],
	},
	publicationDate: {
		name: 'Publication Date (oldest first)',
		filter: [{ datePublished: { order: 'asc', missing: '_last' } }],
	},
	title: {
		name: 'Title (a-z)',
		filter: [{ sortableTitle: { order: 'asc', missing: '_last' } }],
	},
	titleDesc: {
		name: 'Title (z-a)',
		filter: [{ sortableTitle: { order: 'desc', missing: '_last' } }],
	},
	relevance: { name: 'Relevance', filter: undefined }, // default behavior, no filter needed
	//{ value: "UploadDate", name: "Upload date (newest first)" },
	//{ value: "UploadDateDesc", name: "Upload date (oldest first)" }
};
